import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const MapIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="32"
    height="32"
    viewBox="0 0 32 32"
    {...props}
    sx={{ fill: 'none' }}
  >
    <path
      d="M28.615 6.21139C28.4952 6.11805 28.3557 6.05322 28.2072 6.02182C28.0586 5.99041 27.9048 5.99326 27.7575 6.03014L20.1162 7.94014L12.4475 4.10514C12.2338 3.99856 11.9891 3.97196 11.7575 4.03014L3.7575 6.03014C3.54116 6.08422 3.3491 6.20905 3.21185 6.3848C3.0746 6.56056 3.00003 6.77714 3 7.00014V25.0001C3.00002 25.1521 3.03467 25.302 3.10132 25.4386C3.16797 25.5752 3.26486 25.6947 3.38463 25.7882C3.50441 25.8817 3.64392 25.9467 3.79256 25.9782C3.94121 26.0098 4.09508 26.007 4.2425 25.9701L11.8837 24.0601L19.5525 27.8951C19.6917 27.9638 19.8448 27.9997 20 28.0001C20.0818 28.0001 20.1632 27.99 20.2425 27.9701L28.2425 25.9701C28.4588 25.9161 28.6509 25.7912 28.7881 25.6155C28.9254 25.4397 29 25.2231 29 25.0001V7.00014C29 6.84805 28.9654 6.69795 28.8987 6.56127C28.8319 6.42459 28.7349 6.30493 28.615 6.21139ZM13 6.61764L19 9.61764V25.3826L13 22.3826V6.61764ZM5 7.78139L11 6.28139V22.2189L5 23.7189V7.78139ZM27 24.2189L21 25.7189V9.78139L27 8.28139V24.2189Z"
      fill="white"
    />
  </SvgIcon>
);
